import React, { useState } from 'react';
import { ConfirmModal } from '../components/ui/modals/ConfirmModal';

/**
 * Function and dialog box to confirm actions throughout app
 * 
 * @returns {JSX.Element} ConfirmDialog - dialog box component
 * @returns {function} requestConfirm - opens the modal, handles state changes, returns promise (true or false)
 * 
 * @category Hooks
 */
const useConfirmDialog = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [confirmButtonText, setConfirmButtonText] = useState("Yes")
    const [cancelButtonText, setCancelButtonText] = useState("No")
    const [resolve, setResolve] = useState(null); //promise returns true or false depending on user button click
    const [buttonVariant, setButtonVariant] = useState("danger")

    const requestConfirm = (customMessage, confirmButtonText = "Yes", cancelButtonText = "No", buttonVariant = 'danger') => {
        //open modal
        setIsOpen(true);

        //set modal text
        setMessage(customMessage);
        setConfirmButtonText(confirmButtonText)
        setCancelButtonText(cancelButtonText) 
        setButtonVariant(buttonVariant)

        return new Promise((resolve) => {
            setResolve(() => resolve);
        });
    };

    const handleConfirm = () => {
        resolve(true); 
        setIsOpen(false);
    };

    const handleCancel = () => {
        resolve(false);
        setIsOpen(false);
    };

    const ConfirmDialog = () => {
        return(
            <ConfirmModal
                showModal={isOpen} 
                message={message}
                handleConfirm={handleConfirm} 
                handleCancel={handleCancel}
                confirmButtonText={confirmButtonText}
                cancelButtonText={cancelButtonText}
                buttonVariant={buttonVariant}
            />
        )
    }

    return [ConfirmDialog, requestConfirm];
};

export default useConfirmDialog;
